import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const PATOVERVIEWBLOCK_LEGACY_FIELD_ORDER = [];

export type PatOverviewBlockScenarioCheckItem = {
  id: string;
  name: string;
  price: number;
  description: string;
  selected_by: {
    user: string;
    transaction: string;
  };
};

export type PatOverviewBlockScenarioTransaction = {
  id: string;
  amount: number;
  cancellation_reason: string;
  paid_amount: number;
  source: string;
  status: string;
  type: string;
  user: string;
  created_at: string;
  confirmed_at: string | null;
  payment_intent_id: string;
  items: readonly string[];
  tip?: {
    amount: number;
  };
};

export type PatOverviewBlockScenarioCheck = {
  id: string;
  closed_at: string;
  opened_at: string;
  items: readonly PatOverviewBlockScenarioCheckItem[];
  transactions: readonly PatOverviewBlockScenarioTransaction[];
  shop: {
    id: string;
    name: string;
    current_user_roles: readonly unknown[];
  };
  marketplace: {
    id: string;
    name: string;
    current_user_roles: readonly unknown[];
  };
  onsite_location: {
    id: string;
    name: string;
  };
  final_price: number;
  active_transaction?: PatOverviewBlockScenarioTransaction;
  outstanding_amount: number;
  available_payment_methods: readonly unknown[];
  currency: string;
};

export type PatOverviewBlockScenarioContent = {
  check: PatOverviewBlockScenarioCheck | null;
};
const {
  patOverviewBlockDescriptor: _generatedPatOverviewBlockDescriptor,
  patOverviewBlockBlocDefinition,
  patOverviewBlockDashboardLayout,
  patOverviewBlockConfig,
  patOverviewBlockResolveConfig,
  patOverviewBlockProperties,
  patOverviewBlockDefinitionSetupScenarios,
} = doodBlockConfig(
  {
    name: "Pay at table - Overview",
    componentType: 'PatOverviewBlockComponent',
    category: 'pay_at_table',
    description: "Pay at table - Overview.",
    keywords: [],
    sharedFields: {}
  },
  () => ({
    // no scalar props
  }),
  () => ({
    tabs: [
      {
        label: 'Design',
        fieldsets: [
          {
            legend: 'Properties',
            fields: [],
          },
        ],
      },
    ],
  })
);

export function patOverviewBlockDescriptor(): IBlockDescriptor;
export function patOverviewBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function patOverviewBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedPatOverviewBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedPatOverviewBlockDescriptor, patOverviewBlockProperties, fieldOrder);
}

export {
  patOverviewBlockBlocDefinition,
  patOverviewBlockDashboardLayout,
  patOverviewBlockProperties,
  patOverviewBlockConfig,
  patOverviewBlockResolveConfig,
  patOverviewBlockDefinitionSetupScenarios,
};

export type PatOverviewBlockConfig = typeof patOverviewBlockConfig;
